﻿(function ($) {
    $(window).on('load', function () {
        $('.disableUntilPageLoaded').removeClass('disableUntilPageLoaded');
    });
})(jQuery);

window.getParamKeyValue = function(url) {
    url = decodeURIComponent(url);
    var paramkvp = [];
    var urls = url.split("?");
    $.each(urls, function (i, url) {
        var params = url.split("&");
        $.each(params, function (j, param) {
            var index = param.indexOf("=");
            if (index > 0) {
                var key = param.substr(0, index);
                paramkvp.push(key);
                paramkvp[key] = param.substr(index + 1);
                if (i !== urls.length - 1) {
                    paramkvp[key] = param.substr(index + 1) + "?" + urls[i + 1];
                }
            }
        });
    });
    return paramkvp;
}

